import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { BusinessProfile } from '../../models/business/BusinessProfile'
import { BUSINESS_PROFILS_URL } from '../../utils/urls'

const fetchBusinessProfiles = (params: TableParams) =>
  SBAPI.FetchPaginated<BusinessProfile[]>(BUSINESS_PROFILS_URL, params)

const fetchBusinessProfileById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<BusinessProfile>(`${BUSINESS_PROFILS_URL}/${id}`, params)

const createBusinessProfile = (businessProfile: BusinessProfile) =>
  SBAPI.Post(BUSINESS_PROFILS_URL, businessProfile)

const updateBusinessProfile = (businessProfile: BusinessProfile) =>
  SBAPI.Put(`${BUSINESS_PROFILS_URL}/${businessProfile.id}`, businessProfile)

const deleteBusinessProfile = (businessProfile: BusinessProfile) =>
  SBAPI.Delete(`${BUSINESS_PROFILS_URL}/${businessProfile.id}`)

export {
  createBusinessProfile,
  deleteBusinessProfile,
  fetchBusinessProfileById,
  fetchBusinessProfiles,
  updateBusinessProfile,
}
